// extracted by mini-css-extract-plugin
export default {"cls1":"SearchBar-cls1_KSX","cls2":"SearchBar-cls2_hUw SearchBar-cls1_KSX"};